<div fxFlexFill fxLayout="column" fxLayoutGap="10px">

  <!-- Header Section Starts -->
  <span fxLayout="row" class="div-header">
    <span fxFlex fxLayoutAlign="center center" fxLayout="row">
      <span class="heading medium" ngClass.xs="heading-xs medium">{{ 'add_new' | transloco }}</span>
    </span>

    <span style="position: inline;right:0;" fxFlexAlign="center">
      <a class="close medium" (click)="onCancel()">{{ 'cancel' | transloco }}</a>
    </span>
  </span>

  <mat-dialog-content [formGroup]="Addform" fxLayout="column" fxLayoutGap="20px" style="padding-bottom:8%;">
    <!-- Form section Starts -->
    <span fxLayout="column" fxFlexLayoutAlign="center center" class="form-span">
      <mat-form-field>
        <mat-label class="form-label">{{ 'name' | transloco }}</mat-label>
        <input matInput class="input" maxlength="50" formControlName="displayName">
      </mat-form-field>
      <mat-form-field>
        <mat-label class="form-label">{{ 'job_title' | transloco }}</mat-label>
        <input matInput class="input" maxlength="50" formControlName="jobTitle">
      </mat-form-field>
      <span fxLayout="row" fxLayoutGap="10px">
        <mat-form-field fxFlex="30">
          <mat-label class="form-label">{{ 'area_code' | transloco }}</mat-label>
          <input matInput type="tel" class="input" [maxLength]="5" formControlName="areaCode" (focus)="areaCodeFocus()"
          (blur)="areaCodeBlur()">
        </mat-form-field>
        <mat-form-field fxFlex fxFlex.xs="65">
          <mat-label class="form-label">{{ 'contact_number' | transloco }}</mat-label>
          <input matInput type="tel" class="input" [maxLength]="15" formControlName="mobilePhone">
        </mat-form-field>
      </span>

      <mat-form-field>
        <mat-label class="form-label">{{ 'company' | transloco }}</mat-label>
        <input matInput class="input" maxlength="50" formControlName="company">
      </mat-form-field>
    </span>
    <!-- Button Section starts -->
    <div fxLayout="column" fxFlexLayoutAlign="center center">
      <span fxLayoutGap="10px" class="div-btn" fxLayout="row">
        <div fxFlex="50" fxLayoutAlign="start ">
          <button color="primary" ngStyle.xs="width:150px" mat-stroked-button class="reset-button medium" (click)="onReset()"
            >{{ 'reset' | transloco }}</button>
        </div>
        <div fxFlex="50" fxLayoutAlign="end ">
          <button color="primary" ngStyle.xs="width:150px" [disabled]="Addform.invalid" mat-flat-button
            class="add-button medium" (click)="onAdd()" >{{ 'add' | transloco }}</button>
        </div>
      </span>
    </div>

  </mat-dialog-content>
</div>
